<template>
  <div class="indexs">
    <div class="banners">
      <el-carousel
        trigger="click"
        arrow="always"
        indicator-position="none"
        style="height: 100%"
      >
        <el-carousel-item v-for="(item, j) in imglist" :key="j">
          <img :src="item" alt="" class="bannerimg" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="newss">
      <div
        class="newstitle"
        style="
          width: 100%;
          height: 13.33vw;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 3.2vw;
          position: relative;
        "
      >
        <img
          src="../../assets/image/newstitle.png"
          alt=""
          class="newsimg"
          style="width: 26.67vw; height: 13.33vw"
        />
        <img
          src="../../assets/image/news_jt.gif"
          alt=""
          style="width: 2.67vw; height: 4vw; position: absolute; top: 10.67vw"
        />
      </div>
      <el-carousel
        indicator-position="outside"
        height="120vw"
        arrow="never"
        @change="onChange"
      >
        <el-carousel-item v-for="item in 3" :key="item"
          ><div
            class="newscontents"
            style="
              display: flex !important;
              flex-direction: column;
              gap: 2.67vw;
            "
          >
            <div
              class="newslist"
              v-for="(i, j) in newslist"
              @click="checkinfo(i)"
              @touchstart="changecolor(j)"
              style="
                display: flex;
                width: 100%;
                height: 27.73vw;
                background: #fff;
                padding: 3.2vw;
                display: flex;
              "
            >
              <div
                class="listicon"
                style="
                  width: 26.67vw;
                  height: 21.33vw;
                  position: relative;
                  margin-right: 2.67vw;
                  pointer-events: none;
                "
              >
                <img
                  :src="i.firstUrl"
                  alt=""
                  class="listimg"
                  style="width: 100%; height: 100%; pointer-events: none"
                />
                <div
                  class="listtime"
                  style="
                    display: flex;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    pointer-events: none;
                    width: 100%;
                    height: 7.47vw;
                    background: rgba(3, 109, 220, 0.8);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: white;
                    font-size: 3.73vw;
                  "
                >
                  {{ i.createTime }}
                </div>
              </div>
              <div
                class="listcontent"
                style="
                  flex: 1;
                  display: flex;
                  flex-direction: column;
                  pointer-events: none;
                  width: 56.27vw;
                "
              >
                <h1
                  class="listtitle"
                  style="
                    font-size: 4vw;
                    color: #000;
                    margin-bottom: 0.83vw;
                    pointer-events: none;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    height: 5.33vw;
                  "
                  :style="{
                    color: clickstyle == j ? 'rgba(25, 97, 172, 1)' : '#06192D',
                  }"
                >
                  {{ i.title }}
                </h1>
                <p
                  class="listcon"
                  style="
                    font-size: 3.2vw;
                    height: 13.33vw;
                    pointer-events: none;
                    color: rgba(6, 25, 45, 0.68);
                    overflow: hidden;
                  "
                >
                  {{ i.summary }}
                </p>
              </div>
            </div>
          </div></el-carousel-item
        ></el-carousel
      >
    </div>
    <div class="products">
      <div
        class="protitle"
        style="
          width: 100%;
          height: 13.07vw;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 2.08vw;
          position: relative;
        "
      >
        <img
          src="../../assets/image/producttitle.png"
          alt=""
          class="proimg"
          style="width: 48.27vw; padding-left: 3.2vw; height: 13.07vw"
        />
        <img
          src="../../assets/image/news_jt.gif"
          alt=""
          style="width: 2.67vw; height: 4vw; position: absolute; top: 10.67vw"
        />
      </div>
      <div
        style="
          width: 100%;
          padding: 5.33vw 6.13vw;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 3.2vw;
          justify-content: center;
          background: rgba(244, 246, 249, 0.5);
        "
      >
        <img
          src="../../assets/image/pro1.png"
          alt=""
          style="width: 77.33vw; height: 43.73vw"
          @click="turntos(0)"
        />
        <img
          src="../../assets/image/pro2.png"
          alt=""
          style="width: 77.33vw; height: 34.67vw"
          @click="turntos(1)"
        />
        <img
          src="../../assets/image/pro3.png"
          alt=""
          style="width: 77.33vw; height: 34.67vw"
          @click="turntos(2)"
        />
        <img
          src="../../assets/image/pro4.png"
          alt=""
          style="width: 77.33vw; height: 40.8vw"
          @click="turntos(3)"
        />
        <img
          src="../../assets/image/pro5.png"
          alt=""
          style="width: 77.33vw; height: 34.67vw"
          @click="turntos(4)"
        />
      </div>
    </div>
    <div
      class="developments"
      style="
        width: 100%;
        background-image: url('../../assets/image/devbg.png') no-repeat;
        background-size: 100% 100%;
        background-position: 0 0;
        padding: 4vw 8vw;
        display: flex;
        flex-direction: column;
      "
    >
      <div
        class="devtitle"
        style="
          width: 100%;
          height: 13.07vw;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 5.33vw;
          position: relative;
        "
      >
        <img
          src="../../assets/image/mdeveloptitle.png"
          alt=""
          class="devimg"
          style="width: 48.27vw; height: 13.07vw"
        />
        <img
          src="../../assets/image/news_jt.gif"
          alt=""
          style="width: 2.67vw; height: 4vw; position: absolute; top: 10.67vw"
        />
      </div>
      <div class="devcontent" style="width: 100%; position: relative; flex: 1">
        <div
          class="devroll"
          style="
            width: 75.2vw;
            height: 75.2vw;
            background-image: url('../../assets/image/roll.png') no-repeat;
            background-position: 0 0;
            background-size: 100% 100%;
            position: absolute;
            right: calc(50% - 37.6vw);
            top: 46.4vw;
            animation: rotate 5s linear infinite;
          "
        ></div>
        <div
          class="timeline"
          ref="timeline"
          style="width: 100%; position: relative"
        >
          <div
            class="line"
            style="
              width: 0vw;
              height: 336vw;
              border-right: 0.27vw dashed #1961ac;
              margin-left: 3.2vw;
            "
          ></div>
          <div
            style="
              width: 100%;
              height: 48vw;
              position: absolute;
              top: 0;
              left: 0;
              display: flex;
              z-index: 99;
            "
            v-for="(i, j) in timeline"
            :key="j"
            :style="{
              top: `${j * 48}vw`,
            }"
          >
            <div style="width: 6.4vw; height: 6.4vw">
              <img
                :src="
                  devstyles == j
                    ? require('../../assets/image/orangeclock.png')
                    : require('../../assets/image/clock.png')
                "
                alt=""
                style="width: 6.4vw; height: 6.4vw"
              />
            </div>
            <div style="flex: 1; display: flex">
              <div
                style="
                  width: 17.07vw;
                  height: 0.27vw;
                  background: #1961ac;
                  margin-top: 3.2vw;
                "
                :style="{
                  background:
                    devstyles == j
                      ? 'rgba(231, 104, 0, 1)'
                      : 'rgba(25, 97, 172, 1)',
                }"
              ></div>
              <div style="flex: 1; height: 100%" @click="devstyle(j)">
                <div
                  style="
                    padding: 2.13vw;
                    border: 0.27vw solid #1961ac;
                    border-radius: 1.07vw;
                    background-color: #a6cffd;
                    margin-bottom: 3.2vw;
                    width: 70%;
                    height: 8.53vw;
                    color: #1961ac;
                    line-height: 4vw;
                    text-align: center;
                  "
                  :style="{
                    color: devstyles == j ? '#fff' : 'rgba(25, 97, 172, 1)',
                    'background-color':
                      devstyles == j ? 'rgba(231, 104, 0, 1)' : '#E9F2FC',
                    border:
                      devstyles == j
                        ? '.27vw solid rgba(231, 104, 0, 1)'
                        : '.27vw solid #1961AC',
                  }"
                >
                  {{ i.title }}
                </div>
                <p style="color: rgba(6, 25, 45, 0.6); font-size: 3.2vw">
                  {{ i.content }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="linkto"
      style="
        width: 100%;
        height: 42.67vw;
        background: rgba(243, 245, 249, 0.8);
        padding: 3.2vw 4vw;
      "
    >
      <div
        class="linktotitle"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 14.67vw;
          display: flex;
          justify-content: center;
          margin-bottom: 5.33vw;
          position: relative;
        "
      >
        <img
          src="../../assets/image/linkto.png"
          alt=""
          class="linkimg"
          style="width: 26.67vw; height: 14.67vw"
        />
        <img
          src="../../assets/image/news_jt.gif"
          alt=""
          style="width: 2.67vw; height: 4vw; position: absolute; top: 12vw"
        />
      </div>
      <div
        class="linkcontent"
        style="
          width: 100%;
          height: 16vw;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div
          class="links"
          @click="turnto('https://www.mohurd.gov.cn/')"
          style="
            width: 26.67vw;
            height: 16vw;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            background: #fff;
            box-shadow: 0vw 0.16vw 0.78vw 0vw rgba(68, 86, 103, 0.15);
          "
        >
          <img
            src="../../assets/image/link1.png"
            alt=""
            class="linksingle"
            style="width: 26.4vw; height: 9.07vw"
          />
        </div>
        <div
          class="links"
          @click="turnto('http://www.crecg.com/')"
          style="
            width: 28.53vw;
            height: 16vw;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            background: #fff;
            box-shadow: 0vw 0.16vw 0.78vw 0vw rgba(68, 86, 103, 0.15);
          "
        >
          <img
            src="../../assets/image/link2.png"
            alt=""
            class="linksingle"
            style="width: 9.33vw; height: 6.93vw"
          />
        </div>
        <div
          class="links"
          @click="turnto('http://www.crceg.com/')"
          style="
            width: 28.53vw;
            height: 16vw;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            background: #fff;
            box-shadow: 0vw 0.16vw 0.78vw 0vw rgba(68, 86, 103, 0.15);
          "
        >
          <img
            src="../../assets/image/link3.png"
            alt=""
            class="linksingle"
            style="width: 21.6vw; height: 5.87vw"
          />
        </div>
      </div>
    </div>
    <div class="mfooter" style="width: 100%; background: rgba(6, 25, 45, 0.9)">
      <div
        style="
          width: 100%;
          height: 33.33vw;
          background: rgba(6, 25, 45, 0.85);
          padding: 5.33vw 2.67vw;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div
          style="
            width: 32vw;
            height: 22.67vw;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
          "
        >
          <img
            src="../../assets/image/f_ic1.png"
            alt=""
            style="width: 8vw; height: 8vw"
          />
          <p style="color: rgba(255, 255, 255, 0.8); font-size: 3.73vw">
            企业邮箱
          </p>
          <p style="color: rgba(255, 255, 255, 0.8); font-size: 3.2vw">
            2042654646@qq.com
          </p>
        </div>
        <div
          style="
            width: 32vw;
            height: 22.67vw;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
          "
        >
          <img
            src="../../assets/image/f_ic2.png"
            alt=""
            style="width: 8vw; height: 8vw"
          />
          <p style="color: rgba(255, 255, 255, 0.8); font-size: 3.73vw">
            联系我们
          </p>
          <p style="color: rgba(255, 255, 255, 0.8); font-size: 3.2vw">
            (010)63716576
          </p>
        </div>
        <div
          style="
            width: 32vw;
            height: 22.67vw;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
          "
        >
          <img
            src="../../assets/image/f_ic3.png"
            alt=""
            style="width: 8vw; height: 8vw"
          />
          <p style="color: rgba(255, 255, 255, 0.8); font-size: 3.73vw">
            招聘中心
          </p>
          <p style="color: rgba(255, 255, 255, 0.8); font-size: 3.2vw">
            iw0i5u2mkg@msn.com
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tlzf from "../tlzf.vue";
export default {
  components: { Tlzf },
  data() {
    return {
      devstyles: -1,
      clickstyle: -1,
      newsclicks: "",
      imglist: [
        "https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/mbanner1.png",
        "https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/mbanner2.png",
        "https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/mbanner3.png",
        "https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/mbanner4.png",
        "https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/mbanner5.png",
      ],
      newslist: [
        {
          title: "废弃物资源化利用，让建筑“绿”起来",
          content:
            "近日，深圳罗湖区建筑废弃物资源化利用观摩交流会在中铁建设北京公司承建的深圳博元大厦主体建设项目顺利举行。",
          time: "2023-08-09",
          icon: require("../../assets/image/newsicon.png"),
        },
        {
          title: "废弃物资源化利用，让建筑“绿”起来",
          content:
            "近日，深圳罗湖区建筑废弃物资源化利用观摩交流会在中铁建设北京公司承建的深圳博元大厦主体建设项目顺利举行。",
          time: "2023-08-09",
          icon: require("../../assets/image/newsicon.png"),
        },
        {
          title: "废弃物资源化利用，让建筑“绿”起来",
          content:
            "近日，深圳罗湖区建筑废弃物资源化利用观摩交流会在中铁建设北京公司承建的深圳博元大厦主体建设项目顺利举行。",
          time: "2023-08-09",
          icon: require("../../assets/image/newsicon.png"),
        },
        {
          title: "废弃物资源化利用，让建筑“绿”起来",
          content:
            "近日，深圳罗湖区建筑废弃物资源化利用观摩交流会在中铁建设北京公司承建的深圳博元大厦主体建设项目顺利举行。",
          time: "2023-08-09",
          icon: require("../../assets/image/newsicon.png"),
        },
      ],
      tabslist: [
        {
          name: "施工总承包",
          children: [
            {
              name: "铁路站房",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "调度所及铁路配套工程",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "机场",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "文化场馆",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "体育场馆",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "学校",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "地产住宅",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "医疗养老",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "政府办公",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "城市综合体",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "科研基地和研发中心",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
          ],
        },
        {
          name: "工程总承包(EPC)",
          children: [],
          content: [
            { name: "雄安站", icon: require("../../assets/image/case8.png") },
            { name: "雄安站", icon: require("../../assets/image/case2.png") },
            { name: "雄安站", icon: require("../../assets/image/case3.png") },
            { name: "雄安站", icon: require("../../assets/image/case4.png") },
            { name: "雄安站", icon: require("../../assets/image/case5.png") },
            { name: "雄安站", icon: require("../../assets/image/case6.png") },
          ],
        },
        {
          name: "基础设施",
          children: [
            {
              name: "铁路交通",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
              ],
            },
            {
              name: "轨道交通",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
          ],
        },
        {
          name: "建筑工业化",
          children: [],
          content: [
            { name: "雄安站", icon: require("../../assets/image/case8.png") },
            { name: "雄安站", icon: require("../../assets/image/case2.png") },
            { name: "雄安站", icon: require("../../assets/image/case3.png") },
            { name: "雄安站", icon: require("../../assets/image/case4.png") },
          ],
        },
        {
          name: "专业领域",
          children: [
            {
              name: "装饰",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
              ],
            },
            {
              name: "安装",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
              ],
            },
            {
              name: "绿色产业",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "科技创新",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "机械",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
          ],
        },
      ],
      activeName: "施工总承包",
      fathernum: "",
      activechild: "0",
      senddata: null,
      timeline: [
        {
          xy: "top",
          title: "【新中国成立初期】",
          showtitle: "成立初期",
          content:
            "中铁建工集团一公司成立于国家'一五计划'开局之年，前身为铁道部建厂工程公司第一建筑工程处。1959年，仅用7个月零20天，建成中国第一座大型火车站————北京站，创造了中国建筑史上的奇迹。",
        },
        {
          xy: "bot",
          title: "【60年代】",
          showtitle: "60年代",
          content:
            "公司响应党中央'三线建设'重大战略决策，千里奔赴四川资阳，建成资阳内燃机车厂、永济电机厂、偃师摩托车厂等重点工程，为我国国民经济发展和国防现代化建设作出重要贡献",
        },
        {
          xy: "top",
          title: "【70年代】",
          showtitle: "70年代",
          content:
            "公司听从国家召唤，奉命组建援建坦桑铁路的施工队伍。1976年，全长1860公里的坦赞铁路正式交付，见证了中非患难与共的珍贵情谊。1978年，总部迁回北京，建设了北方交通大学扩建工程、铁道部大红门材料厂等工程。",
        },
        {
          xy: "bot",
          title: "【90年代】",
          showtitle: "90年代",
          content:
            "公司在行业内率先推行全面质量管理，推出精品工程生产线质量管理体系和用户服务保障体系，全面提升管理品质，履约能力和品牌美誉度，亮马河大厦、幸福大厦获得全国首批鲁班奖，公司获评国家建筑施工一级企业。",
        },
        {
          xy: "top",
          title: "【21世纪初】",
          showtitle: "21世纪初",
          content:
            "公司不断精进专业实力，国家图书馆万吨钢结构整体提升创造世界纪录，同时摘得鲁班奖、詹天佑奖；承建中国高铁第一站——北京南站，始终保持铁路站房、公众建筑建设领域的行业领先地位。",
        },
        {
          xy: "bot",
          showtitle: "十三五时期",
          title: "【十三五时期】",
          content:
            "公司抢抓市场机遇，承建雄安站、清河站、北京丰台站、北京城市副中心站等重大铁路站房，叫响“铁路站房建设王牌军”金字招牌。提质量增效益，经济指标屡创新高，稳居中国中铁20强前三。",
        },
        {
          xy: "top",
          showtitle: "十四五时期",
          title: "【十四五时期】",
          content:
            "公司持续推进转型升级，构建“1+6”市场布局，建立“总部一分公司一项目部”三级管理模式，明确“十四五”期间的奋斗目标：“工程总承包第一品牌，高质量发展行业典范”,绘制公司未来发展的壮阔蓝图。",
        },
      ],
      scroll: {},
    };
  },
  methods: {
    onChange(e) {
      this.getnewslist(e + 1);
    },
    checkinfo(e) {
      let data = {
        category: "首页/新闻中心",
        id: e.id,
        current: 1,
        size: 999,
      };
      this.$router.push({
        path: "/mnewsinfo",
        query: data,
      });
    },
  
    async getnewslist(e) {
      let data = {
        category: "首页/新闻中心",
        current: e,
        size: 4,
      };
      let res = await this.$http.newslist(data);
      if (res.code == 200) {
        this.newslist = res.data;
      }
    },
    devstyle(e) {
      this.devstyles = e;
    },
    changecolor(e) {
      this.clickstyle = e;
    },
    gotoinfo(e, index) {
      this.$router.push({
        path: "/mnewsinfo",
        query: { infodata: e },
      });

      this.clickstyle = -1;
    },
    turntos(e) {
      this.$router.push({
        path: "/mproduct",
        query: {
          index: e,
        },
      });
    },
    turnto(e) {
      window.open(e);
    },
    childclick(f, l) {
      this.fathernum = f;
      this.activechild = l;
      for (let i in this.tabslist) {
        if (i == f) {
          for (let j in this.tabslist[i].children) {
            if (j == l) {
              this.senddata = this.tabslist[i].children[l].content;
            }
          }
        }
      }
    },
    handleClick(f) {
      this.fathernum = f.index;
      this.activechild = 0;
      for (let i in this.tabslist) {
        if (i == f.index) {
          if (this.tabslist[i].children.length > 0) {
            for (let j in this.tabslist[i].children) {
              if (j == 0) {
                this.senddata = this.tabslist[i].children[j].content;
              }
            }
          } else {
            this.senddata = this.tabslist[i].content;
          }
        }
      }
    },
    newsclick(e) {
      this.newsclicks = e;
    },
  },
  mounted() {
    this.childclick(0, 0);
    this.getnewslist(1);
  },
  destroyed() {
    this.scroll.destroy();
  },
};
</script>

<style scoped lang="less">
::v-deep .el-carousel__container {
  height: 100%;
}
.indexs {
  width: 100vw;
  .products {
    .prochildren {
      .listbox {
        .childactive {
          color: white !important;
          background: #1961ac;
          border: 0.05vw solid #1961ac !important;
        }
        .childrenlist {
          width: auto;
          padding: 0vw 0.73vw;
          height: 1.88vw;
          color: rgba(6, 25, 45, 0.6);
          font-size: 4.27vw;
          border-radius: 0.21vw;
          border: 0.05vw solid rgba(6, 25, 45, 0.5);
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
        }
        display: flex;
        gap: 0.83vw;
        height: 1.88vw;
        justify-content: center;
        align-items: center;
        margin-bottom: 2.08vw;
      }

      width: 100%;
      background: rgba(244, 246, 249, 1);
      padding: 1.25vw 13.54vw 7.29vw 13.54vw;
    }
    .protitle {
      .proimg {
        width: 48.27vw;
        padding-left: 3.2vw;
        height: 13.07vw;
      }
      width: 100%;
      height: 13.07vw;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 2.08vw;
    }
    width: 100%;
    height: 100%;
    background: white;
    padding-top: 3.2vw;
    background: rgba(244, 246, 249, 0.5);
  }
  .timeline::-webkit-scrollbar {
    display: none !important; /* Chrome Safari */
  }
  .developments {
    .devcontent {
      .timeline {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        position: relative;
      }
      .devroll {
        width: 75.2vw;
        height: 75.2vw;
        background: url("../../assets/image/roll.png") no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
        position: absolute;
        right: calc(50% - 37.6vw);
        top: 46.4vw;
        animation: rotate 5s linear infinite;
        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      }
      @keyframes rotate {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
      width: 100%;
      position: relative;
      flex: 1;
    }
    .devtitle {
      .devimg {
        width: 48.27vw;
        height: 13.07vw;
      }
      width: 100%;
      height: 13.07vw;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 1.04vw;
    }
    width: 100%;
    background: url("../../assets/image/devbg.png") no-repeat;
    background-size: 100% 100%;
    background-position: 0 0;
    padding: 4vw 8vw;
    display: flex;
    flex-direction: column;
  }
  .linkto {
    .linkcontent {
      .links {
        .linksingle {
          width: 28.53vw;
          height: 16vw;
        }
        width: 28.53vw;
        height: 16vw;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background: #fff;
        box-shadow: 0vw 0.16vw 0.78vw 0vw rgba(68, 86, 103, 0.15);
      }
      width: 100%;
      height: 16vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .linktotitle {
      .linkimg {
        width: 26.67vw;
        height: 14.67vw;
      }
      width: 100%;
      height: 14.67vw;
      display: flex;
      justify-content: center;
      margin-bottom: 2.08vw;
    }
    width: 100%;
    height: 42.67vw;
    background: rgba(243, 245, 249, 0.8);
    padding: 3.2vw 4vw;
  }
  .newss {
    .newscontents {
      .newslist {
        .listcontent {
          .listcon {
            font-size: 3.2vw;
            height: 13.33vw;
            pointer-events: none;
            color: rgba(6, 25, 45, 0.68);
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden !important;
            line-height: 4.5vw;
          }
          .listtitle {
            font-size: 4vw;
            color: #000;
            margin-bottom: 0.83vw;
            pointer-events: none;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 5.33vw;
          }
          flex: 1;
          display: flex;
          flex-direction: column;
          pointer-events: none;
          width: 56.27vw;
          overflow: hidden;
        }
        .listicon {
          .listtime {
            position: absolute;
            bottom: 0;
            left: 0;
            pointer-events: none;
            width: 100%;
            height: 7.47vw;
            background: rgba(3, 109, 220, 0.8);
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
            font-size: 3.73vw;
          }
          .listimg {
            width: 100%;
            height: 100%;
            pointer-events: none;
          }
          width: 26.67vw;
          height: 21.33vw;
          position: relative;
          margin-right: 2.67vw;
          pointer-events: none;
        }
        width: 100%;
        height: 27.73vw;
        background: #fff;
        padding: 3.2vw;
        display: flex;
      }

      display: flex !important;
      flex-direction: column;
      gap: 2.67vw;
    }
    .newstitle {
      .newsimg {
        width: 26.67vw;
        height: 13.33vw;
      }
      width: 100%;
      height: 13.33vw;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 3.2vw;
    }
    width: 100%;
    height: 100%;
    background: url("../../assets/image/newsbg.png") no-repeat;
    background-size: 100% 100%;
    background-position: 0 0;
    padding: 3.47vw;
  }
  .banners {
    .el-carousel__arrow {
      background: rgba(255, 255, 255, 0.5);
    }
    .el-carousel__arrow--left {
      left: 13.54vw;
    }
    .el-carousel__arrow--right {
      right: 13.54vw;
    }
    .bannerimg {
      width: 100%;
      height: 42.67vw;
    }
    width: 100%;
    height: 42.67vw;
  }
}
.el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}
.el-tabs__item {
  font-size: 5.33vw !important;
  color: rgba(6, 25, 45, 0.7) !important;
}
.el-tabs__item:hover {
  color: #1968bc !important;
}
.devroll {
  width: 75.2vw;
  height: 75.2vw;
  background: url("../../assets/image/roll.png") no-repeat;
  background-position: 0 0;
  background-size: 100% 100%;
  position: absolute;
  right: calc(50% - 37.6vw);
  top: 46.4vw;
  animation: rotate 5s linear infinite;
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
::v-deep .el-carousel__indicators .is-active .el-carousel__button {
  height: 1.6vw !important;
  width: 8vw !important;
  background: #1961ac !important;
}
::v-deep.el-carousel .el-carousel__button {
  width: 2.67vw !important;
  height: 1.6vw !important;
  background: rgba(6, 25, 45, 0.3) !important;
  border-radius: 1.07vw;
}
::v-deep .el-carousel__arrow {
  background-color: rgba(0, 0, 0, 0.4);
  width: 6.4vw;
  height: 6.4vw;
}
::v-deep .el-carousel__arrow:active {
  background: rgba(255, 255, 255, 0.6);
}
</style>
